export default __webpack_public_path__ + "static/media/lottery-random-galactic-punks.366a04c9.png";